import Student from './component';
import StudentInfoBar from './StudentInfoBar';

export default () => ({
  path: 'student/:studentId',
  component: Student,
  appBars: {
    preSticky: {
      'student-info': {
        component: StudentInfoBar,
        order: 1,
      },
    },
  },
  breadcrumbLabels: {
    label: ' ',
    backLinkHref: '/',
  },
  tabs: {
    hidden: true,
  },
});



// WEBPACK FOOTER //
// ./containers/Student/routes.js